import Chip from '@mui/material/Chip';
import { chooseColor } from '../../utils/colors';

const colorMap = new Map([
  ['Mitarbeiter', '#46146E'],
  ['Reporter', '#B4C5E4'],
  ['Maintainer', '#EE8434'],
  ['Administrator', '#A31621'],
  ['HR-Manager', '#0F8B8D'],
]);

const roleColor = (name) => {
  return colorMap.get(name)
};

function RoleChip({ name }) {
  const color = roleColor(name)
  return <Chip label={name} sx={{ backgroundColor: color, color: chooseColor(color) }} />
}

export default RoleChip
